<div class="trigger">
    <img
        [src]="isHovered ? triggerImageHoveredURL : (triggerImageURL | widgetResourceUrl)"
        [ngClass]="triggerImageCustomClass"
        (click)="changeAction()"
        (mouseenter)="isHovered = true"
        (mouseleave)="isHovered = false"
    />
</div>
